import { getConfig } from './firebaseConfigurationLoader';

export const environment = {
  production: false,
  debugFirestore: false,
  name: 'test',
  sentrySamplerate: 1.0,
  sentryEnabled: true,
  version: 'phaenonet-client@6479f7c91cf358202d85a0ba218795562c4e02b5',
  firebaseConfig: getConfig()
};
